module.exports = __webpack_public_path__ + "img/9788995683644.63045a1a.jpg";